module.exports = __webpack_public_path__ + "p9_img2.jpg?e89e892338a654bf8f04828bacfe1c29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p9/p9_img2.jpg
// module id = 136
// module chunks = 0